import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import Modal from '../modal/Modal';
import FilterAccordionSelect from "../accordion/AccordionFilterSelect";
import Sidebar from "./Sidebar";
import { SectionBanner } from "../cart/CheckoutHelpers";
export var SortNFilter = function SortNFilter(props) {
  var close = props.close,
      show = props.show,
      sortByChange = props.sortByChange,
      _props$total = props.total,
      total = _props$total === void 0 ? 15 : _props$total;
  return /*#__PURE__*/React.createElement(Modal, {
    className: "cb-menu-secondary cb-search__sortnfilter__modal",
    show: show,
    hide: close,
    title: "Sort and Filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__preview__lower cb-search__sortnfilter"
  }, /*#__PURE__*/React.createElement(SectionBanner, {
    showNumber: false
  }, "Sort By..."), /*#__PURE__*/React.createElement(FilterAccordionSelect, _extends({}, props, {
    changeHandler: function changeHandler(e) {
      e.persist();
      sortByChange(e.target.value);
    }
  })), /*#__PURE__*/React.createElement(SectionBanner, {
    showNumber: false
  }, "Filter By..."), /*#__PURE__*/React.createElement(Sidebar, props), /*#__PURE__*/React.createElement("div", {
    className: "cb-search__sortnfilter__cta"
  }, /*#__PURE__*/React.createElement("button", {
    className: "cb-button-primary",
    onClick: close
  }, "Showing ", total, " Results"))));
};